import React, { Component } from 'react';

import Botao from './Botao';
import { PlaylistAddCheck } from '@mui/icons-material';

class BotaoVisto extends Component {
    render() {
        return (
            <div title="Selecionar processos para enviar para inclusão em pauta de julgamento">
                <Botao label="Visualizar"
                    redirectTo="/escaninho/vistos"
                    pathnameConfig={['/adicionarControleGabinete', '/configuracaoGabinete']}
                    startIcon={<PlaylistAddCheck />}
                />
            </div>
        );
    }
}

export default BotaoVisto;